import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import TextField from '@mui/material/TextField'
import Axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
import server from '../variables'

const AddSchemeModal = ({ show, handleClose,fetch }) => {
  const notyf = new Notyf()
  const navigate = useNavigate()

  const [scheme, setScheme] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const textFieldProps = {
    variant: 'outlined',
    size: 'small',
    fullWidth: true,
  }

  const handleInpChange = (event) => {
    if (event.target.name === 'schemeName') {
      setScheme({
        ...scheme,
        schemeName: event.target.value,
        managerEmail: `${event.target.value
          .toLowerCase()
          .replace(/ /g, '_')}.admin@rean.co.in`,
      })
    } else {
      setScheme({
        ...scheme,
        [event.target.name]: event.target.value,
      })
    }
  }

  const addUser = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    if (
      !scheme.schemeName ||
      !scheme.managerEmail ||
      !scheme.managerName ||
      !scheme.projectname ||
      !scheme.managerPass
    ) {
      notyf.error('Please fill all the fields!')
      setIsLoading(false)
      return
    }

    try {
      const { data } = await Axios.post(
        server + 'admin/new-scheme',
        scheme,
        {
          headers: { authorization: localStorage.getItem('token') },
        }
      )

      setIsLoading(false)

      if (data.status === 410) {
        navigate('/')
      } else if (data.status === 200) {
        notyf.success('Scheme registration successful!')
        handleClose()
        fetch()
        navigate('/admin/dashboard')
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      setIsLoading(false)
      notyf.error('Internal Server Error!')
    }
  }

  useEffect(() => {
    document.title = 'Rean Billing System'
  }, [])

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-semibold fs-5">
          Add Scheme
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-2 pb-4">
        <div className="d-flex justify-content-center">
          <form style={{ width: '100%', maxWidth: '520px' }}>
            <TextField
              {...textFieldProps}
              label="Scheme Name *"
              name="schemeName"
              onChange={handleInpChange}
              className="mb-3"
            />

            <TextField
              {...textFieldProps}
              label="Scheme Manager's Email"
              value={scheme.managerEmail || ''}
              InputLabelProps={{ shrink: true }}
              disabled
              className="mb-3"
            />

              <TextField
              {...textFieldProps}
              label="Project Name"
              value={scheme.projectname || ''}
               onChange={handleInpChange}
             className="mb-3"
               name="projectname"
            />

               <TextField
              {...textFieldProps}
              label="District Name"
              value={scheme.districtname || ''}
               onChange={handleInpChange}
             className="mb-3"
               name="districtname"
            />

            <TextField
              {...textFieldProps}
              label="Manager's Name *"
              name="managerName"
              onChange={handleInpChange}
              className="mb-3"
            />

            <TextField
              {...textFieldProps}
              label="Manager's Password *"
              type="password"
              name="managerPass"
              onChange={handleInpChange}
              className="mb-4"
            />

            <button
              className="btn btn-primary w-100 py-2 fw-semibold"
              disabled={isLoading}
              onClick={addUser}
              style={{ borderRadius: '8px' }}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm me-2" />
              ) : (
                'Register Scheme'
              )}
            </button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AddSchemeModal
